import { render, staticRenderFns } from "./AUserSelector.vue?vue&type=template&id=b89818a2&"
import script from "./AUserSelector.vue?vue&type=script&lang=js&"
export * from "./AUserSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports